import React, {useState, useRef, useEffect, Fragment} from 'react';
import TrueFalseToggle from '../TrueFalseToggle';
import VisDiv from '../frontend_components/VisDiv'
import { richEditorDoc } from '../gestioneDatabase/Docs'
import RichTextEditor from '../RichTextEditor'
import SaveButton from '../frontend_components/SaveButton'
import { useStateContext } from '../../context/StateContext';
import { ImportExcelButton } from '../../lib/excel';
import { errorAlert, sortByLabel, unique } from '../../lib/utils';
import TextField from '../TextField';
import { keyId } from '../../lib/utils'
import { v4 as uuidv4 } from 'uuid';
import {FiEdit, FiSave } from 'react-icons/fi'
import { useCreateReplace } from '../../hooks/mutations';
import PromiseQueue from 'p-queue'
import ManageSchema from '../../components/management/ManageSchema';
import SchemaImport from '../../sanity_ecommerce/schemas/rich-module/richTextLabelValue'
import { successAlert } from '../../lib/utils';
import Divider from '../frontend_components/Divider';
import { useQueryClient } from '@tanstack/react-query';
import { DecimalHours } from '../management/ManagementModules';
import SliderRegistriTemplates from '../SliderRegistriTemplates';
import FieldDropdown from '../FieldDropdown';
import { isArray } from 'lodash';

/**
 * CustomerProductDetailUpdate component
 * 
 * This component renders a list of customer products with filters for template and search
 * it is setup to change the details.
 * @param {object} data - an object containing the data needed by the component,  {documents, queryKey, field, fieldType, title, templateRegisters, referenceExpandedArray}
 * 
 * @returns - a JSX element
 */
const CustomerProductDetailUpdate = ({data={}}) => {
         // search-box
         const [searchValue, setSearchValue] = useState("");
         const[registerTemplateFilter, setRegisterTemplateFilter] = useState()
         const searchRef = useRef();
         const {
            customer,
            setLoading,
        } = useStateContext();
     
        const familyFilter = (x) => {
            if(registerTemplateFilter){
                if(x?.registers?.length > 0) {
                   return x?.registers?.some?.((y)=>y?._ref == registerTemplateFilter?._id)
                }
                return x == x
            }
            return x == x
        }
         const searchFilter = (x) =>{
             // search-box
            const search =  x?.label?.toLowerCase()?.indexOf(searchValue.toLowerCase()) >= 0
            return search 
        }
            //search-box
            const onSearchClick = (e) => {
             e.stopPropagation()
           };
           const onSearch = (e) => {
             setSearchValue(e.target.value);
           };
    const {documents, queryKey, field, fieldType, title, templateRegisters, referenceExpandedArray} = data
  
  return (
    <div style={{overflow:"auto", height:"88vh", paddingBottom:"100px" }}>
        <h2 onClick={()=>console.log("FILTER:", referenceExpandedArray)}>{title}</h2>
        <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
            <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearch} value={searchValue} ref={searchRef} />
        </div>
        <VisDiv rules={[templateRegisters]}>
                <h4>FILTRA PER FAMIGLIA</h4>
                <SliderRegistriTemplates 
                    registerTemplateFilter={registerTemplateFilter} 
                    setRegisterTemplateFilter={setRegisterTemplateFilter} 
                    templates={!Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>x?.customer?._ref == customer?._id)} 
                    setLoading={setLoading}
                />
            </VisDiv>
        {!Array.isArray(documents) ? [] : documents?.filter?.(familyFilter)?.filter?.(searchFilter)?.sort(sortByLabel)?.map?.((item, index)=>{
            
            return (
            <div key={item?._id}>
                <DetailPin referenceExpandedArray={referenceExpandedArray} queryKey={queryKey} index={index} field={field} fieldType={fieldType} item={item}/>
            </div>
            )
        })
     
        }
    </div>
  )
}

export default CustomerProductDetailUpdate

/**
 * DetailPin component, used to display and edit the details of a pin in the pin management page.
 * 
 * @param {object} item - the pin object to be displayed
 * @param {string} key - the key of the pin object
 * @param {string} fieldType - the type of the field to be edited (e.g. number, boolean, referenceArray)
 * @param {string} field - the name of the field to be edited
 * @param {number} index - the index of the pin in the array
 * @param {string} queryKey - the key of the query to be updated
 * @param {array} referenceExpandedArray - the array of reference objects to be used in the field dropdown
 */
export const DetailPin = ({item={}, key, fieldType, field, index, queryKey, referenceExpandedArray }) => 

    {
        const queryClient = useQueryClient()
        const rowColour = index % 2 ? "white":"#e6e6e6"
        const [value, setValue] = useState(item)
/*         useEffect(()=>{
            if(!item) console.log("NON CARICATO", item)
            setValue(item)
        },[item]) */
        const {mutate: updateDocument} = useCreateReplace({
            onMutate: async (newDoc) => {

                await queryClient.cancelQueries({ queryKey: [queryKey] })
                const previousData = queryClient.getQueryData([queryKey])
           
                //const doc = newDoc?.doc
                
                queryClient.setQueryData([queryKey], (old) =>{ 
                    const doc = newDoc?.doc
                    const existingDocs = !old ? [] : old?.filter?.(x=>x?._id!== doc._id)
                    const newData = [...existingDocs?.filter?.(x=>x?._id!== doc._id), doc]          
                    return newData
                })
                return {previousData}
            },
            onError: (err, newDoc, context) => {
                console.error('Oh no, the update failed: ', err?.message)
                errorAlert("Errore: il documento non é stato aggiornato")
            }
            })

        const existingValue = value[`${field}`] 
        const booleanValue = !value[`${field}`] ? false : true
        const referenceOptions = referenceExpandedArray?.map?.((item)=>({label: item?.label || item?.family, value: item.label || item.family, reference: {_ref:item?._id, _key: keyId(), _type: "reference"}}))
        const referenceExistingValue = isArray(existingValue) && existingValue?.map?.((item=> !Array.isArray(referenceOptions) ? undefined : referenceOptions?.find?.((x)=>x?.reference?._ref == item?._ref)))
        const updateValue = (e) => {

            const fieldValue = () => {
                if(fieldType == "number") return Number(e.target.value)
                if(fieldType == "boolean") return !booleanValue
                if(fieldType == "hoursMinutes") return value[`${field}`]
                if(fieldType == "referenceArray") return e
                return e.target.value
            }
            const newValue = {
                ...value, 
                [field]: fieldValue()
            }
            setValue(newValue)
            if(fieldType == "boolean") {
                updateDoc(newValue)
            }
            if(fieldType == "referenceArray") {
                updateDoc(newValue)
                //console.log("smqlkdmqmkd", newValue, e, fieldValue())
            }
       
            
        }
        const updateDoc = (value) => {
            
            const queryDoc = {
                doc: value,
            }
            console.log("SAVE DOC:", queryDoc)
            updateDocument(queryDoc)
        }
        const pinTestFunction = () => {
            console.log("pin test", value, )
            console.log("options", referenceOptions, existingValue)
            navigator.clipboard.writeText(value?._id)

        }

        const hourDoc = (data) => {
            console.log("DECIMAL MINUTES", data)
            const doc = {...value, [`${field}`]: data?.decimal}
            updateDoc(doc)
        }

        const fieldToEdit = () => {
            if(fieldType == "boolean") return <TrueFalseToggle value={booleanValue} onClick={updateValue}/>  
           // <TextField type="number" onChange={(e)=>updateValue(e)} value={value[`${field}`]}/>
            if(fieldType == "number") return  <TextField onBlur={()=>{updateDoc(value)}} type="number" onChange={(e)=>updateValue(e)} value={existingValue}/>
            if(fieldType == "hoursMinutes") return <DecimalHours 
                initialDecimalValue={existingValue} 
                docFn={hourDoc} 
                //defaultMinutes={30}
                //description={"Inserire il numero di ore di manodopera. il default è di mezz'ora se lasciato vuoto"} 
                //label={"ORE MANODOPERA (DECIMALE)"}
                //descriptionDivider={true}
            />
            if(fieldType == "referenceArray") return <FieldDropdown
                //value={existingValue}
                isMulti={true}
                options = {referenceOptions}
                initialValue={referenceExistingValue}
                isSearchable="isSearchable"
                onChange={(value) => {
                    const newValue = value?.map?.((x)=>x?.reference)
                    //console.log("kcskcdoscdpkc", newValue)
                    updateValue(newValue)
                }}
            />
            return <TextField type="text" onChange={(e)=>updateValue(e)} value={existingValue}/>
        }

        return (
            <VisDiv style={{padding: "3px", backgroundColor:rowColour}}>
                <VisDiv rules={[false]}>
                    <button onClick={pinTestFunction}>testPin</button>
                </VisDiv>
               
                <VisDiv style={{display:"flex",marginLeft:"10px", justifyContent:"left", alignItems:"center"}}>
                    <VisDiv onClick={()=>{pinTestFunction()}} rules={[true]} style={{marginRight:"10px"}}> 
                        <p>{item?.label}</p>
                      
                    </VisDiv>
                    <div style={{marginRight:"10px"}}>
                         {fieldToEdit()}
                    </div>
                    <VisDiv rules={[false]}>
                        <button type='button' className='round-back-button' style={{backgroundColor:"green"}} onClick={()=>updateDoc()}>
                            <FiSave            
                            size={15}
                            color={"white"}/>
                        </button>
                    </VisDiv>
                </VisDiv>
            </VisDiv>
        )
    }
